import React from 'react'
import Link from 'gatsby-link'

import logo from '../images/logo.svg'
import logoBlack from '../images/logo-black.svg'
import logoGray from '../images/logo-gray.svg'
import logoBlue from '../images/logo-blue.svg'

const LocusLabs = ({darkTheme}) => (
  <div className="logo">
    <Link to="/">
      <img
        className="default-logo"
        src={darkTheme ? logo : logoBlack}
        width="150"
        height="24"
        alt="LocusLabs"
      />
      <img
        className="hover-logo"
        src={logoBlue}
        width="150"
        height="24"
        alt="LocusLabs"
      />
    </Link>
  </div>
)

export default LocusLabs



// WEBPACK FOOTER //
// ./src/components/LocusLabs.js